import { KoobInputSelect, KoobInputLabel } from '@koob/ui';
import { useField } from 'formik';
import { FormField, ErrorMessageWrapper } from 'ui/forms';
import { Stack } from '@koob/margaret';
import { isArray } from 'lodash';

const formatError = error => {
  if (isArray(error)) {
    return error.filter(Boolean)?.[0];
  }
  return error;
};

const LocalMultiSearchableSelectField = ({
  name,
  label,
  rightLabel,
  onSelectOption,
  touchRequired = true,
  options,
  required,
  renderOption,
  disabled,
  placeholder,
  creatable = false,
  formatCreateLabel,
  onCreateOption,
}) => {
  const [{ value }, { touched, error }, { setValue }] = useField({ name });
  const hasError =
    (!touchRequired || Boolean(touched)) && Boolean(formatError(error));
  const selected = value ?? [];

  return (
    <FormField>
      {(label || rightLabel) && (
        <Stack alignX="space-between" alignY="center">
          {label && <KoobInputLabel label={label} required={required} />}
          {rightLabel}
        </Stack>
      )}
      <KoobInputSelect
        multiple
        searchable
        creatable={creatable}
        formatCreateLabel={formatCreateLabel}
        disabled={disabled}
        placeholder={placeholder}
        options={options ?? []}
        value={selected.map(option => option.value)}
        onValueChange={values => {
          // formik keeps whole option objects, as it always did; a value with
          // no matching option is a creatable free-text entry
          const next = [];
          values.forEach(v => {
            const option =
              (options ?? []).find(item => item.value === v) ??
              selected.find(item => item.value === v);
            if (option) {
              next.push(option);
            } else if (creatable && onCreateOption) {
              onCreateOption(v);
            }
          });
          setValue(next);
          if (onSelectOption) {
            const added = next.find(
              option => !selected.some(s => s.value === option.value),
            );
            if (added) {
              onSelectOption(added);
            }
          }
        }}
        renderOption={renderOption && (option => renderOption(option))}
        error={hasError}
        data-testid={name}
      />
      {Boolean(hasError) && (
        <ErrorMessageWrapper>{formatError(error)}</ErrorMessageWrapper>
      )}
    </FormField>
  );
};

export default LocalMultiSearchableSelectField;
